// Shared bus for primary series navigation points.
// SpeedTrace publishes its current (zoom-aware) first-series points so that
// the keyboard-navigation hook can step through them without coupling to any
// specific chart component.
//
// Each point: { distFt, lat, lon, videoTime }

let _points = [];

export function publishSeriesPoints(pts) {
  _points = pts;
}

export function getSeriesPoints() {
  return _points;
}

export function clearSeriesPoints() {
  _points = [];
}
